import {SupportRegionCard} from "@/components/templates/key_value_page/content/content--support";
import {useContext} from "react";
import {Dictionary} from "@/types/hygiena-types";
import {DictionaryContext} from "@/context/dictionary-context";

export function ParagraphSupportCards({paragraph, ...props}) {
  const t = useContext<Dictionary>(DictionaryContext);
  if (!paragraph?.field_src_support_regions?.length) {
    return <></>;
  }

  return (
    <div className="paragraph-support-cards container flex flex-col md:flex-row justify-between gap-2">
      {paragraph.field_src_support_regions?.map((item, i) => (
        <SupportRegionCard title={item.name} phone={item.field_sr_phone} calendarText={t.all.schedule_meeting_technical} calendarLink={item.field_sr_calendar_link?.uri} key={`support-region-card--${item.id}`} icon={item.field_sr_icon} select={item.field_sr_region_id ?? item.name} />
      ))}
    </div>
  )
}